'use client';

import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions, BOOKMARK_TYPE, UnauthQueryOptions } from '@/api';
import { BookmarkButton } from '@/components/molecule/BookmarkButton';
import { useBookmark } from '@/hooks/useBookmark';
import { useAuthStore } from '@/stores/AuthStore';

interface PolicyInfoContentBookmarkButtonProps {
  id: number;
  idIdx: string;
  title?: string;
}

export const PolicyInfoContentBookmarkButton = ({
  id,
  idIdx,
  title,
}: PolicyInfoContentBookmarkButtonProps) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const { bookmark } = useBookmark();

  const feedback = useQuery({
    ...(isLogin
      ? AuthQueryOptions[
          'get:/wello/v2/auth/contents/feedback/{bestContentsId}'
        ]
      : UnauthQueryOptions[
          'get:/wello/v2/allows/contents/best/feedback/{bestContentsId}'
        ])({
      path: {
        bestContentsId: id,
      },
    }),
    staleTime: 0,
    select: ({ context }) => ({
      isBookmarked: context?.wishlistYN,
      bookmarkCount: context?.wishlistCount,
    }),
    enabled: isLogin !== undefined,
  });

  return (
    <BookmarkButton
      {...feedback.data}
      onClick={(isBookmarked) => {
        bookmark({
          bookmarkType: BOOKMARK_TYPE.POLICY_INFO,
          idx: idIdx,
          contentId: id,
          isBookmarked,
          contentName: title,
        });
      }}
    />
  );
};
